const RULES = {
    length: (value) => value.length >= 12,
    lowercase: (value) => /[a-z]/.test(value),
    uppercase: (value) => /[A-Z]/.test(value),
    digit: (value) => /\d/.test(value),
    special: (value) => /[^A-Za-z0-9]/.test(value),
};

function initPasswordRequirements() {
    document.querySelectorAll('[data-password-requirements]').forEach((list) => {
        const input = document.getElementById(list.dataset.passwordRequirements);
        const items = list.querySelectorAll('[data-rule]');

        if (!input || !items.length) {
            return;
        }

        const update = () => {
            items.forEach((item) => {
                const isMet = RULES[item.dataset.rule]?.(input.value) ?? false;
                item.classList.toggle('is-met', isMet);
            });
        };

        input.addEventListener('input', update);
        update();
    });
}

export default initPasswordRequirements;
